import { Observable } from "rxjs";

import { OrdersRepository } from "lib/repositories/index";
import st from "lib/utils/index";
import { createResourceInstance } from "modules/utils/index";

export const INITIALIZE_VIEW = "orders/ShowOrderView/INITIALIZE_VIEW";
export const LOAD_ORDER = "orders/ShowOrderView/LOAD_ORDER";
export const SHOW_LOADER = "orders/ShowOrderView/SHOW_LOADER";
export const FETCH_ORDER = "orders/ShowOrderView/FETCH_ORDER";
export const FETCH_ORDER_START = "orders/ShowOrderView/FETCH_ORDER_START";
export const FETCH_ORDER_SUCCESS = "orders/ShowOrderView/FETCH_ORDER_SUCCESS";
export const FETCH_ORDER_FAILURE = "orders/ShowOrderView/FETCH_ORDER_FAILURE";

export const stateSelector = (state) => state.orders.ShowOrderView;

const orderResource = createResourceInstance({
  LOAD: LOAD_ORDER,
  FETCH: FETCH_ORDER,
  FETCH_START: FETCH_ORDER_START,
  FETCH_SUCCESS: FETCH_ORDER_SUCCESS,
  FETCH_FAILURE: FETCH_ORDER_FAILURE,
  stateSelector,
  stateKey: "order",
  getModel: ({ orderId, orderToken }) => {
    return OrdersRepository.find(orderId, orderToken);
  },
});

const initialState = {
  order: orderResource.initialState,
  orderId: null,
  orderToken: null,
};

const reducers = {
  ...orderResource.reducersMap,

  [INITIALIZE_VIEW]: (state, { orderId, orderToken }) => ({
    ...initialState,
    orderId,
    orderToken,
  }),
};

const epics = [...orderResource.epics, (actions$) => actions$.ofType(INITIALIZE_VIEW).mapTo(fetchOrder())];

export const { fetch: fetchOrder, load: loadOrder } = orderResource.actions;

export function initializeView(orderId, orderToken) {
  return { type: INITIALIZE_VIEW, orderId, orderToken };
}

export function showLoader() {
  return { type: FETCH_ORDER_START };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/orders/ShowOrderView/index.js